export const finder = (data, key, value, prop) => {
  const find = data?.find(({ attributes }) => attributes[key] === value);
  return find ? find.attributes[prop] : null;
}